import React from 'react';
import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AuthorsAndReferences = ({ handoutData, open = false, onToggleAuthorsAndReferences }) => {
    const formatDate = (timestamp) => {
        if (!timestamp) return 'Date not available';

        const date = new Date(timestamp);
        return date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };

    const citations = handoutData?.citationList?.values || [];

    // CETRA-754: Keep author dialog headings aligned with the design spec.
    const headingSx = {
        color: '#0A0F63',
        fontSize: '42px',
        fontWeight: 600,
        lineHeight: 1,
    };

    return (
        <Dialog
            open={open}
            onClose={onToggleAuthorsAndReferences}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: { xs: '20px', md: '28px' },
                    margin: { xs: 2, md: 4 },
                    maxWidth: '760px',
                },
            }}
        >
            <DialogContent sx={{ px: { xs: 3, md: 5 }, py: { xs: 3, md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, mb: 3 }}>
                    <Typography sx={headingSx}>Authors</Typography>
                    <IconButton
                        onClick={onToggleAuthorsAndReferences}
                        aria-label="Close authors and references"
                        sx={{
                            width: 40,
                            height: 40,
                            backgroundColor: '#E6E6E6',
                            flex: '0 0 auto',
                            '&:hover': {
                                backgroundColor: '#DADADA',
                            },
                        }}
                    >
                        <CloseIcon sx={{ color: '#5A5A5A', fontSize: 30 }} />
                    </IconButton>
                </Box>

                <Typography sx={{ color: '#3E3E3E', fontSize: 15.5, mb: 1.5 }}>
                    {handoutData?.writtenBy
                        ? `Written by ${handoutData.writtenBy}`
                        : 'Author information not available'}
                </Typography>
                <Typography sx={{ color: '#3E3E3E', fontSize: 15.5, mb: 1.5 }}>
                    {handoutData?.reviewedBy
                        ? `Reviewed by ${handoutData.reviewedBy}`
                        : 'Reviewer information not available'}
                </Typography>
                <Typography sx={{ color: '#3E3E3E', fontSize: 15.5, mb: 6 }}>
                    Updated {formatDate(handoutData?.lastUpdated)}
                </Typography>

                {citations.length > 0 && (
                    <>
                        <Typography sx={{ ...headingSx, mb: 3 }}>Sources</Typography>

                        <Box component="ol" sx={{ m: 0, pl: 3, color: '#3E3E3E' }}>
                            {citations.map((citation, index) => (
                                <Typography
                                    key={index}
                                    component="li"
                                    sx={{
                                        fontSize: 15.5,
                                        lineHeight: 1.45,
                                        mb: 1.5,
                                        pl: 0.5,
                                    }}
                                >
                                    {citation}
                                </Typography>
                            ))}
                        </Box>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default AuthorsAndReferences;
